export default __webpack_public_path__ + "static/media/298.05067d33.png";